import React from 'react';
import { Card, InfoCard, Button } from '../../components';
import { COLORS } from '../../constants';
import './DashboardPage.css';
import BottomNav from '../../components/BottomNav/Boomnav';
import { ImExit } from 'react-icons/im';

const DashboardPage = ({ balance, availableBalance, isActivated, onNavigate }) => {
  // O valor inicial do lucro total deve ser 0
  let lucroBot = 0;
  let base = 0;
  try {
    const user = JSON.parse(localStorage.getItem('usuarioLogado'));
    const saldoInicial = user && typeof user.saldoInicial === 'number' ? user.saldoInicial : 0;
    // Se não houver saldoInicialBase, define como saldoInicial atual (primeiro acesso ou zerado)
    if (user && typeof user.saldoInicialBase !== 'number') {
      user.saldoInicialBase = saldoInicial;
      localStorage.setItem('usuarioLogado', JSON.stringify(user));
    }
    base = user && typeof user.saldoInicialBase === 'number' ? user.saldoInicialBase : saldoInicial;
    lucroBot = saldoInicial - base;
  } catch (e) { }
  let nomeUsuario = '';
  try {
    const user = JSON.parse(localStorage.getItem('usuarioLogado'));
    nomeUsuario = user && user.name ? user.name : '';
  } catch (e) { }

  const [active, setActive] = React.useState('dashboard');
  const handleNavChange = (id) => {
    setActive(id);
    if (onNavigate) onNavigate(id);
  };

  return (
    <div className="dashboard-page">
      <header className="dashboard-header">
        <div>
          <div className="header-label">PAINEL PRINCIPAL</div>
          <div className="header-title">Olá{nomeUsuario ? `, ${nomeUsuario}` : ', Investidor'}</div>
        </div>
        <button
          className="logout-btn"
          title="Sair"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#6886af',
            fontSize: 30,
            marginLeft: 16,
            marginTop: 10,
          }}
          onClick={() => {
            if (window.confirm('Deseja realmente sair?')) {
              if (typeof onNavigate === 'function') {
                localStorage.removeItem('usuarioLogado');
                onNavigate('login');
              }
            }
          }}
        >
          <ImExit />
        </button>
      </header>

      <InfoCard title="Visão Geral da Conta">
        Acompanhe seu saldo, metas e o status operacional da Prisma IA em tempo real.
      </InfoCard>

      <div className="balance-card">
        <div className="balance-label" style={{ marginTop: 8, fontSize: 13, color: '#00c689' }}>Saldo Disponível</div>
        <div className="balance-value text-mono" style={{ fontSize: 22, color: '#00c689' }}>$ {availableBalance !== undefined ? availableBalance.toFixed(2) : balance.toFixed(2)}</div>
        <div className="balance-yield text-mono">
          {lucroBot >= 0 ? '+' : ''}$ {lucroBot.toFixed(2)} Lucro Total
        </div>
      </div>
      {!isActivated && (
        <div className="activation-alert">
          <div className="alert-icon">🔒</div>
          <div className="alert-content">
            <div className="alert-title">Conta Bloqueada</div>
            <div className="alert-description">
              Necessário ativar código de simulação.
            </div>
          </div>
          <Button
            onClick={() => onNavigate('activation')}
            variant="danger"
            style={{
              height: '36px',
              width: '80px',
              fontSize: '10px',
            }}
          >
            ATIVAR
          </Button>
        </div>
      )}

      <Card style={{ background: '#2a3347' }}>
        <div className="card-header">
          <div className="card-title">Status do Robô</div>
          <span className="status-badge active">ONLINE</span>
        </div>
        <div className="card-info">
          <span>Ativos Monitorados:</span>
          <strong>5 Mercados</strong>
        </div>
      </Card>
      <BottomNav active={active} onChange={handleNavChange} />
    </div>
  );
};

export default DashboardPage;